// Chris 31.10: after «Legg i handlekurv» the drawer opens only when Candy Rack and Shopify have
// answered, about 1.5 s. The button shows at once that it is working (assets/dr-kurv.css) and
// goes back when the cart has updated or failed, when Candy Rack opens its popup, or after
// 8 s at the latest. It only changes the look: the theme's own click handling is untouched.
(function () {
  if (window.drKurv) return;
  window.drKurv = true;

  var aktive = [];
  var vakt = null;

  function ferdig() {
    aktive.forEach(function (knapp) {
      knapp.classList.remove('dr-legger');
    });
    aktive = [];
    clearInterval(vakt);
    vakt = null;
  }

  document.addEventListener('click', function (event) {
    var knapp = event.target.closest && event.target.closest('.add-to-cart-button');
    // The quick-add «Velg» button opens a window instead of adding.
    if (!knapp || knapp.disabled || knapp.classList.contains('quick-add__button--choose')) return;
    var start = Date.now();
    // After the theme's own handler, so a blocked add (no size picked) never shows the ring.
    setTimeout(function () {
      if (knapp.form && !knapp.form.checkValidity()) return;
      knapp.classList.add('dr-legger');
      aktive.push(knapp);
      clearInterval(vakt);
      vakt = setInterval(function () {
        if (document.body.classList.contains('candyrack-body-open') || Date.now() - start > 8000) ferdig();
      }, 150);
    });
    // Capture: the theme's form stops the click before it reaches the document.
  }, true);

  document.addEventListener('cart:update', ferdig, true);
  document.addEventListener('cart:error', ferdig, true);

  // Chris 1.11: the upsell's quantity as the same − 1 + stepper as the items in the cart,
  // instead of the phone's own list. Christian's select stays the one that counts
  // (assets/cart-upsell.js reads it); the stepper only sets it. The drawer is drawn again
  // after each change, so new upsells get their stepper as they appear.
  function trinn(velg) {
    if (velg.hasAttribute('data-dr-trinn')) return;
    velg.setAttribute('data-dr-trinn', '');
    var verdier = Array.prototype.map.call(velg.options, function (o) { return Number(o.value); });
    var min = Math.min.apply(null, verdier);
    var maks = Math.max.apply(null, verdier);
    var boks = document.createElement('div');
    boks.className = 'dr-trinn';
    boks.innerHTML = '<button type="button" aria-label="Færre">−</button><output aria-live="polite"></output><button type="button" aria-label="Flere">+</button>';
    var knapper = boks.querySelectorAll('button');
    var tall = boks.querySelector('output');
    function vis() {
      var n = Number(velg.value);
      tall.textContent = n;
      knapper[0].disabled = n <= min;
      knapper[1].disabled = n >= maks;
    }
    function sett(n) {
      velg.value = String(Math.min(maks, Math.max(min, n)));
      velg.dispatchEvent(new Event('change', { bubbles: true }));
      vis();
    }
    knapper[0].addEventListener('click', function () { sett(Number(velg.value) - 1); });
    knapper[1].addEventListener('click', function () { sett(Number(velg.value) + 1); });
    velg.classList.add('visually-hidden');
    velg.setAttribute('tabindex', '-1');
    velg.parentNode.insertBefore(boks, velg);
    vis();
  }

  function alleTrinn() {
    document.querySelectorAll('select.cart-upsell__quantity:not([data-dr-trinn])').forEach(trinn);
  }

  alleTrinn();
  new MutationObserver(alleTrinn).observe(document.body, { childList: true, subtree: true });
})();
